import React, { useEffect, useState } from "react";
import { DatePicker } from "@material-ui/pickers";

interface DataPikerFieldProps {
  date: Date | null;
  field: string;
  label: string;
  onChange(field: string, date: Date| null): any;
  disablePast?: boolean;
  disableToday?: boolean;
}

export const DatePickerField = ({
  date,
  field,
  label,
  onChange,
  disablePast,
  disableToday,
}: DataPikerFieldProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleDate = (date: Date | null) => {
    setSelectedDate(date);
    onChange(field, date);
  };

  useEffect(() => {
    date && setSelectedDate(date);
  }, [date]);

  return (
    <DatePicker
      fullWidth
      name={field}
      margin="normal"
      variant="inline"
      format="dd.MM.yyyy"
      id={field}
      label={label}
      inputVariant="filled"
      value={selectedDate}
      onChange={handleDate}
      autoOk
      clearable
      disablePast={disablePast}
      shouldDisableDate={
        disableToday
          ? (day) => {
              if (!day) return false;
              const today = new Date();
              return (
                day.getDate() === today.getDate() &&
                day.getMonth() === today.getMonth() &&
                day.getFullYear() === today.getFullYear()
              );
            }
          : undefined
      }
      //disableFuture={field === 'startDate'}
    />
  );
};
